<template>
    <div class='h100vh-150 h-normalBg'>
        <div class='h-ainfoBg'>
            <div class='h-ainfo'>
                <span class='icon hero-icon hero-icon-detailcode'></span>
                <span>{{$t('Monitor.realTimeMonitoring.CPUUtilization')}}： {{ CPUUtilization }}%</span>
            </div>
        </div>
        <div class='h-normalContainter'>
                <div class='row h-nomargin h-full-container width-100vw h100-80'>
                    <div id='cpuMonitor' class='width-100vw h100' style="height:599px"></div>
                </div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts';

export default{
    name: "realtimeCpuMonitor",
    data() {
        return {
            data: [],
            charts: "",
            app: {},
            myChart: null,
            xData: [],
            CPUUtilization: 0
        };
    },
    methods: {
        initData() {
            this.myChart = echarts.init(document.getElementById('cpuMonitor'));
            for (var i=0;i<12;i++){
                if(i==11){
                    this.xData.push('0');
                }else if (i==0){
                    this.xData.push('60s')
                }else{
                    this.xData.push('');
                }
                this.data.push('-');
            }
            let option = this.getChartOption();
            if (option && typeof option === 'object') {
                this.myChart.setOption(option);
            }
        },
        random(min,max){
            return Math.floor(Math.random()*(max-min))+min;
        },
        randomData() {
            return this.random(20,60);
        },
        getMonitorData(CPUUtilization) {
            this.CPUUtilization=CPUUtilization;
            if(this.data.length>=12){
                this.data.shift();
            }
            this.data.push(CPUUtilization);
            this.myChart.clear();
            this.myChart.setOption(this.getChartOption(),true);
            this.myChart.resize();
        },
        getChartOption() {
            const option = {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                    return params[0].value;
                    },
                    axisPointer: {
                    animation: false
                    }
                },
                xAxis: {
                    type: 'category',
                    data: this.xData,
                    boundaryGap: false
                },
                yAxis: {
                    name: "%",
                    type: 'value',
                    min: 0,
                    max: 100,
                    axisLabel: {
                        formatter: '{value}'
                    }
                },
                series: [
                    {
                        type: 'line',
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: 'rgb(232,248,252)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgb(203,227,243)'
                                    }
                                ],
                                global: false
                            }
                        },
                        data: this.data,
                        lineStyle: {
                            color: '#4097c9'
                        }
                    }
                ]
            };
            return option;
        }
    },
    mounted() {
        this.initData();
    }
}
</script>
